export const collapseFilterSelect = (state) => state.etfBuilder.isFilterVisible;

export const errorMessageSelect = (state) => state.etfBuilder.errorMessage;

export const selectedPortfolioSelect = (state) =>
  state.etfBuilder.selectedPortfolio;

export const isSavingSelect = (state) => state.etfBuilder.isSaving;

export const selectedFilterSelect = (state) => state.etfBuilder.selectedFilter;

export const selectedAssetsSelect = (state) => state.etfBuilder.selectedAssets;

export const selectedIsUnsaved = (state) => state.etfBuilder.isUnsaved;

export const selectedShowBacktestTab = (state) =>
  state.etfBuilder.showBacktestTab;

export const selectedDisabledSave = (state) => state.etfBuilder.disabledSave;
